import { Field, Section, TagInput, CheckboxPill, LANGUAGE_CODES } from "./_shared";
import PhotoGallery from "@/components/wizard/PhotoGallery";

const PAY_METHODS = [
    { key: "card_stripe", label: "Kartë (Stripe)" },
    { key: "paypal", label: "PayPal" },
    { key: "cash", label: "Kesh në hotel" },
    { key: "bank_transfer", label: "Transfertë bankare" },
    { key: "local_gateway", label: "Gateway lokal" },
];

export default function Step5BookingEngine({ data, update, draft }) {
    const slug = (draft?.data?.step1?.hotel_name || "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "") || "hoteli-yt";
    return (
        <>
            <Section title="Faqja e rezervimit" description="Widget rezervimi direkt për faqen tënde web.">
                <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
                    <Field label="Subdomain" hint={`${slug}.book.akomoda.co`}>
                        <div className="flex items-center gap-1">
                            <input className="akm-input" value={data.subdomain || slug} onChange={(e) => update({ subdomain: e.target.value })} />
                            <span className="font-mono text-[11px] text-muted-foreground">.book.akomoda.co</span>
                        </div>
                    </Field>
                    <Field label="Domain i personalizuar" hint="CNAME opsional"><input className="akm-input" value={data.custom_domain} onChange={(e) => update({ custom_domain: e.target.value })} placeholder="book.hoteliyt.com" /></Field>
                </div>
            </Section>

            <Section title="Branding">
                <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
                    <Field label="Ngjyra e brand-it">
                        <div className="flex items-center gap-2">
                            <input type="color" value={data.brand_color} onChange={(e) => update({ brand_color: e.target.value })} className="h-9 w-12 rounded-md border border-border" />
                            <input className="akm-input flex-1 font-mono" value={data.brand_color} onChange={(e) => update({ brand_color: e.target.value })} />
                        </div>
                    </Field>
                    <Field label="URL e logos"><input className="akm-input" value={data.logo_url} onChange={(e) => update({ logo_url: e.target.value })} placeholder="https://…/logo.png" /></Field>
                </div>
                <Field label="Fotot e hotelit" hint="Ngarko nga PC ose ngjit URL. Fotoja e parë përdoret si kopertinë. Tërhiq për të rirenditur.">
                    <PhotoGallery
                        value={data.photos || []}
                        onChange={(v) => update({ photos: v })}
                        kind="hotel-photo"
                        testId="wizard-hotel-photos"
                    />
                </Field>
                <Field label="Gjuhët" hint="Vetëm kode ISO (p.sh. sq, en, it, de, fr)">
                    <TagInput
                        value={data.languages || []}
                        onChange={(v) => update({ languages: v })}
                        placeholder="sq, en, it…"
                        restrictTo={LANGUAGE_CODES}
                        normalize={(v) => v.toLowerCase().slice(0, 2)}
                    />
                </Field>
            </Section>

            <Section title="Metodat e pagesës në rezervim">
                <div className="flex flex-wrap gap-1.5">
                    {PAY_METHODS.map((p) => (
                        <CheckboxPill
                            key={p.key}
                            checked={(data.payment_methods || []).includes(p.key)}
                            onChange={(v) => update({ payment_methods: v ? [...(data.payment_methods || []), p.key] : (data.payment_methods || []).filter((x) => x !== p.key) })}
                            testId={`pay-${p.key}`}
                        >{p.label}</CheckboxPill>
                    ))}
                </div>
            </Section>

            <Section title="Kodet promocionale">
                <Field label="Kodet promocionale aktive" hint="p.sh. SUMMER20, EARLY10. Shtyp Enter për të shtuar.">
                    <TagInput value={data.promo_codes || []} onChange={(v) => update({ promo_codes: v })} placeholder="VERE20" />
                </Field>
            </Section>

            <Section title="Ligjore">
                <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
                    <Field label="URL e Kushteve"><input className="akm-input" value={data.terms_url} onChange={(e) => update({ terms_url: e.target.value })} placeholder="https://…/kushtet" /></Field>
                    <Field label="URL e Politikës së Privatësisë"><input className="akm-input" value={data.privacy_url} onChange={(e) => update({ privacy_url: e.target.value })} placeholder="https://…/privatesia" /></Field>
                </div>
            </Section>
        </>
    );
}
